import PageViewsPresenter from "../components/page-views/presenter/page-views.js";

const pageViewsComponent = new PageViewsPresenter();
pageViewsComponent.init();
